/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Studyprograms1Inputs */

const en__field_studyprograms1 = /** @type {(inputs: _Field_Studyprograms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Study Programs`)
};

const de__field_studyprograms1 = /** @type {(inputs: _Field_Studyprograms1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studiengänge`)
};

/**
* | output |
* | --- |
* | "Study Programs" |
*
* @param {_Field_Studyprograms1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_studyprograms1 = /** @type {((inputs?: _Field_Studyprograms1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Studyprograms1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_studyprograms1(inputs)
	return de__field_studyprograms1(inputs)
});
export { _field_studyprograms1 as "_field_studyPrograms" }